import { BASE_API_URL } from './index';

export const billingEndpoint = `${BASE_API_URL}/billing/`;

export const billingCodesEndpoint = `${billingEndpoint}codes/`;
